function nw_roomvo_crosslink_observer() {
  var observ_form = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var img = jQuery(".shopify-product-form img.roomvo-stimr");
      if (img.length) {
        //hide image if appear
        img.hide();
        var link = jQuery("span.nw-roomvo-crosslink");
        if (link.length) {
          jQuery(".nw-cross-links-section").addClass("two-cols-50");
          jQuery(".nw-cross-links-section").removeClass("horisontal-style");
          jQuery(".nw-roomvo-box").addClass("active");
        }
        // stop observ_form
        observ_form.disconnect();
      }
    });
  });
  var targetNodes = document.getElementsByClassName("shopify-product-form");
  if (targetNodes.length > 0) {
    observ_form.observe(targetNodes[0], {
      childList: true,
      subtree: true,
    });
  }
}

function nw_roomvo_crosslink_click() {
  $("span.nw-roomvo-crosslink").on("click", function () {
    $(".shopify-product-form img.roomvo-stimr").click();
  });
}
/*
function nw_slider_cross_sell() {
  var sliderContainer = $(".nw-cross-sell-slider-wrap");
  var flickity_nw_cross_sell_slider = null;

  function nw_cross_sell() {
    var containerWidth = sliderContainer.width();
    var totalItemsWidth = 36;
    sliderContainer.find(".cross-sell-slider-item").each(function () {
      totalItemsWidth += $(this).outerWidth();
    });
    console.log("totalItemsWidth ", totalItemsWidth);
    console.log("containerWidth ", containerWidth);
    if (totalItemsWidth > containerWidth) {
      if (flickity_nw_cross_sell_slider === null) {
        sliderContainer.removeClass("no-slider");
        flickity_nw_cross_sell_slider = new Flickity(sliderContainer[0], {
          cellAlign: "center",
          contain: true,
          wrapAround: true,
          autoPlay: false,
          prevNextButtons: true,
          pageDots: false,
          draggable: true,
        });

        var currentProduct = sliderContainer.find(".current-product");
        if (currentProduct.length) {
          var currentProductIndex = currentProduct.index();
          if (currentProductIndex !== -1) {
            setTimeout(function () {
              flickity_nw_cross_sell_slider.select(currentProductIndex);
            }, 500);
          }
        }
      }
    } else {
      if (flickity_nw_cross_sell_slider) {
        flickity_nw_cross_sell_slider.destroy();
        flickity_nw_cross_sell_slider = null;
      }
      sliderContainer.addClass("no-slider");
    }
  }
  nw_cross_sell();
  $(window).resize(function () {
    nw_cross_sell();
  });
}
*/

function nw_slider_cross_sell() {
  var sliderContainer = jQuery(".nw-cross-sell-slider-wrap");
  if (!sliderContainer.length) {
    return;
  }
  var containerWidth = sliderContainer.width();
  var totalItemsWidth = 36;
  sliderContainer.find(".cross-sell-slider-item").each(function () {
    totalItemsWidth += jQuery(this).outerWidth();
  });
  if (totalItemsWidth > containerWidth) {
    if (!sliderContainer.data("nw_flickity_slider_instance")) {
      sliderContainer.removeClass("no-slider");
      var nw_flickity_slider_instance = new Flickity(sliderContainer[0], {
        cellAlign: "center",
        contain: true,
        wrapAround: true,
        autoPlay: false,
        prevNextButtons: true,
        pageDots: false,
        draggable: true,
      });

      sliderContainer.data(
        "nw_flickity_slider_instance",
        nw_flickity_slider_instance
      );

      var currentProduct = sliderContainer.find(".current-product");
      if (currentProduct.length) {
        var currentProductIndex = currentProduct.index();
        if (currentProductIndex !== -1) {
          setTimeout(function () {
            nw_flickity_slider_instance.select(currentProductIndex);
          }, 500);
        }
      }
    }
  } else {
    var nw_flickity_slider_instance = sliderContainer.data(
      "nw_flickity_slider_instance"
    );
    if (nw_flickity_slider_instance) {
      nw_flickity_slider_instance.destroy();
      sliderContainer.removeData("nw_flickity_slider_instance");
    }
    sliderContainer.addClass("no-slider");
  }
}

function nw_slider_cross_sell_init() {
  nw_slider_cross_sell();
  var resizeTimeout;
  $(window).on("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      nw_slider_cross_sell();
    }, 200);
  });
}

function nw_product_hover_image_handlers() {
  //NW Product Grid Item Hoover Image
  jQuery(".nw-has-hover-image").on("mouseenter", function () {
    jQuery(".nw-has-hover-image").removeClass("active");
    jQuery(this).addClass("active");
  });
  jQuery(".nw-has-hover-image").on("mouseleave", function () {
    jQuery(this).removeClass("active");
  });
  jQuery(".nw-has-hover-image").on("touchmove", function () {
    jQuery(".nw-has-hover-image").removeClass("active");
    jQuery(this).addClass("active");
  });
}

function nw_tab_container() {
  $(".nw-tab-container").each(function () {
    var section = $(this);
    var tab_buttons = section.find(".tab-button");
    var tab_contents = section.find(".tab-content");
    var tab_wrap = section.find(".tab-wrap");
    tab_buttons.on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("active")) {
        return;
      }
      var target = $(this).data("tab");
      // switch active button
      tab_buttons.removeClass("active");
      $(this).addClass("active");

      // toggle container active class
      if ($(this).is('[data-tab="tab-style"]')) {
        tab_wrap.addClass("active");
      } else {
        tab_wrap.removeClass("active");
      }
      // fade tabs
      tab_contents.filter(":visible").fadeOut(200, function () {
        tab_contents.filter('[data-tab="' + target + '"]').fadeIn(200);
      });
    });
  });
}
function nw_mobile_nav_toggle() {
  $("#menuHamburger, .close-mobile-nav").on("click", function () {
    $(".nw-mobile-nav-container").toggleClass("active");
    if ($(".nw-mobile-nav-container").hasClass("active")) {
      $("body").addClass("nw-lock-scroll-mobile");
    } else {
      $("body").removeClass("nw-lock-scroll-mobile");
    }
  });
}
function nw_header_search_toggle() {
  var section = $(".nw-header-section");
  if (section.length) {
    var search_icon = section.find(".nw-header-search-icon");
    var search_bar = section.find(".nw-header-search-bar");
    var search_close = section.find(".nw-search-close");
    search_icon.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $("body").addClass("nw-search-active");
      if ($("predictive-search").hasClass("is-active")) {
        $("body").addClass("predictive-overflow-hidden");
      }
    });
    search_bar.on("click", function (e) {
      e.stopPropagation();
    });
    search_close.on("click", function (e) {
      e.preventDefault();
      $("body").removeClass("nw-search-active");
      $("body").removeClass("predictive-overflow-hidden");
    });
    section.find(".predictive__screen").on("click", function (e) {
      $("body").removeClass("nw-search-active");
      $("body").removeClass("predictive-overflow-hidden");
    });

    $(document).on("click", function (e) {
      if (!$("body").hasClass("nw-search-active")) return;
      var is_outside_search_bar =
        $(e.target).closest(".nw-header-search-bar").length === 0;
      if (is_outside_search_bar) {
        $("body").removeClass("nw-search-active");
        $("body").removeClass("predictive-overflow-hidden");
      }
    });
  }
}
function nw_expand_content() {
  var contentHeight = "46px";
  $(".nw-expandable-content-container").each(function () {
    var nw_content = $(this).find(".expandable-content");
    var nw_button = $(this).find(".show-hide-button");
    nw_content.css("height", contentHeight);
    nw_button.click(function () {
      if (nw_content.hasClass("expanded")) {
        nw_content.animate({ height: contentHeight }, 500);
        nw_content.removeClass("expanded");
        nw_button.text("Read more +");
      } else {
        var fullHeight = nw_content.css("height", "auto").height();
        nw_content.height(contentHeight);
        nw_content.animate({ height: fullHeight }, 500);
        nw_content.addClass("expanded");
        nw_button.text("Read less -");
      }
    });
  });
}
function nw_observe_element(options) {
    const container_selector = options.container_selector;
    const target_selector = options.target_selector;
    const when_loaded = options.when_loaded;
    //get all containers
    const all_containers = document.querySelectorAll(container_selector);
    //console.log('all containers', all_containers);
    //start observe for each element
    all_containers.forEach(container => {
        //create observer to listen for DOM changes
        const observer = new MutationObserver((mutations, obs) => {
            //start function if target element appear
            if (container.querySelector(target_selector)) {
                when_loaded(container);
                obs.disconnect();// stop observing
            }
        });
        observer.observe(container, {
            childList: true, //listen add or remove child element
            subtree: true //listen whole subtree
        });
    });
}
function nw_related_products(){
    function when_loaded_related_products(container) {
        nw_product_hover_image_handlers();
    }
    nw_observe_element({
        container_selector: 'product-recommendations',
        target_selector: '.grid-product__content',
        when_loaded: when_loaded_related_products
    })
}

function nw_slider_gallery_add_numbers() {
  const carousel = $('.product-slideshow');
  if (!carousel.length) return;

  const status = $('.nw-carousel-status');
  if (!status.length) return;

  const changeStatus = () => {
    const gallery_slides = carousel.find('.product-main-slide');
    const total = gallery_slides.length;
    const index = gallery_slides.filter('.is-selected').data('index') + 1;
    if (index) {
      status.text(index +'/' +total);
    }
  };
  const observer = new MutationObserver(changeStatus);
  observer.observe(carousel[0], { attributes: true, subtree: true, attributeFilter: ['class'] });
  changeStatus();
}

function nw_observe_element_multi_targets(options) {
  const container_selector = options.container_selector;
  const target_selector = options.target_selector;
  const target_min_count = options.target_min_count || 1; //minimum of elements that needs to appear
  const when_loaded = options.when_loaded;


  const all_containers = document.querySelectorAll(container_selector);

  all_containers.forEach(container => {
    // immediate check
    const initial_targets = container.querySelectorAll(target_selector);
    if (initial_targets.length >= target_min_count) {
      when_loaded(container);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const targets = container.querySelectorAll(target_selector);
      if (targets.length >= target_min_count) {
        when_loaded(container);
        obs.disconnect();
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });
  });
}

function nw_check_trustpilot_mini_widget() {
  function when_loaded_mini_widget(container) {
    var iframes = container.querySelectorAll('iframe');
    var section = container.closest('.trustpilot-reviews');
    if (iframes.length === 2) {
      section.classList.add('active');
      if ($('.trustpilot-reviews-title').length) {
        $('.trustpilot-reviews-title').fadeIn();
      }
    } else {
      section.classList.remove('active');
    }
  }
  nw_observe_element_multi_targets({
    container_selector: '.nw-trustpilot-product-mini-widget',
    target_selector: 'iframe',
    target_min_count: 2,
    when_loaded: when_loaded_mini_widget
  });
}

function nw_refresh_trustpilot_after_collection_ajax_reload() {
  const widgets = document.getElementsByClassName("trustpilot-widget");
  for (let i = 0; i < widgets.length; i++) {
    window.Trustpilot.loadFromElement(widgets[i]);
  }
  nw_check_trustpilot_mini_widget();
}
document.addEventListener('collection:reloaded', nw_refresh_trustpilot_after_collection_ajax_reload);

function nw_media_alt_related_product(){
  let popup = $('#nw-media-related-product-popup');
  if ($('.nw-media-related-products-section').length) {
    if (popup.length === 0) {
      popup = $('<div id="nw-media-popup-box-container"><div class="nw-media-popup-box-inner"></div><div class="popup-bg close-popup"></div></div>').appendTo('body');
    }
  }
  $('.nw-media-related-product-button').on('click', function(e) {
    e.preventDefault();
    const container = $(this).closest('.nw-media-related-products-section');
    const wrapper = container.find('.nw-media-related-products-container');

    popup.find('.nw-media-popup-box-inner').html(wrapper.html());
    popup.addClass('active');
    $('body').addClass('nw-lock-scroll');
  });
  $(document).on('click', '.close-popup', function(e) {
    e.preventDefault();
    $('#nw-media-popup-box-container').removeClass('active');
    $('body').removeClass('nw-lock-scroll');
  });
}

jQuery(document).ready(function ($) {
  nw_mobile_nav_toggle();
  nw_header_search_toggle();
  nw_roomvo_crosslink_observer();
  nw_roomvo_crosslink_click();
  nw_slider_cross_sell_init();
  nw_product_hover_image_handlers();
  nw_related_products();
  nw_tab_container();
  nw_expand_content();
  nw_slider_gallery_add_numbers();
  nw_check_trustpilot_mini_widget();
    nw_media_alt_related_product();
});